import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import Discover from './pages/Discover/Discover';
import Auth from './pages/Auth/Auth';
import Profile from './pages/Profile/Profile';
import Transactions from './pages/transactions/Transactions';
import Settings from './pages/Settings/Settings';
import EditProfile from './pages/Profile/EditProfile';
import Contracts from './pages/Contracts/Contracts';
import ContractDetail from './pages/Contracts/ContractDetail';
import CreateContract from './pages/Contracts/CreateContract';
import EditContract from './pages/Contracts/EditContract';
import TrialDetail from './pages/TrialSubmissions/TrialDetail';
import TrialSubmissions from './pages/TrialSubmissions/TrialSubmissions';
import BusinessPlan from './pages/BizPlan/BusinessPlanPage';
import './styles/global.css';
import './styles/components.css';

import Messages from './pages/Messages/Messages';
import SystemMessages from './pages/Messages/SystemMessages';
import { TagPlayground } from './pages/Tags/TagPlayground';
import ProtectedRoute from './components/Auth/ProtectedRoute';

// Contracts v2 demo (mocked, in-memory; new contract/fulfillment model).
import { ContractsV2Provider } from './pages/ContractsV2/ContractsV2Context';
import ContractsListPage from './pages/ContractsV2/ContractsListPage';
import ContractDetailPageV2 from './pages/ContractsV2/ContractDetailPage';
import ContractCreatePage from './pages/ContractsV2/ContractCreatePage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/business-plan" element={<BusinessPlan />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/profile/:id/me" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/profile/edit" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
          <Route path="/trials" element={<ProtectedRoute><TrialSubmissions /></ProtectedRoute>} />
          <Route path="/trials/:id" element={<ProtectedRoute><TrialDetail /></ProtectedRoute>} />
          <Route path="/contracts" element={<ProtectedRoute><Contracts /></ProtectedRoute>} />
          <Route path="/contracts/create" element={<ProtectedRoute><CreateContract /></ProtectedRoute>} />
          <Route path="/contracts/:id/edit" element={<ProtectedRoute><EditContract /></ProtectedRoute>} />
          <Route path="/contracts/:id" element={<ProtectedRoute><ContractDetail /></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/messages/:id" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/system-messages" element={<ProtectedRoute><SystemMessages /></ProtectedRoute>} />
          <Route path="/system-messages/:id" element={<ProtectedRoute><SystemMessages /></ProtectedRoute>} />
          <Route path="/tag-playground" element={<TagPlayground />} />

          {/*
            Contracts v2 — demo routes for the new contract/fulfillment model.
            All state is in-memory; ContractsV2Provider seeds two example
            bundles. Provider wraps each leaf so navigation between them
            persists state via the URL/router; for true cross-route
            persistence we use a session-storage backed provider in the
            ContractsV2Context implementation. Will replace /contracts/*
            once finalized.
          */}
          <Route path="/contracts-v2/*" element={
            <ContractsV2Provider>
              <Routes>
                <Route index element={<ContractsListPage />} />
                <Route path="new" element={<ContractCreatePage />} />
                <Route path=":id" element={<ContractDetailPageV2 />} />
              </Routes>
            </ContractsV2Provider>
          } />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
